import React from "react";
import { Checkbox } from "react-form";

export default ({ label, ...rest }) => {
  return (
    <div className="field">
      <div className="control">
        <label className="checkbox">
          <Checkbox {...rest} />
          &nbsp; {label}
        </label>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/form-fields/Checkbox.js